/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Paymentform from './Paymentform';
import Logo from '../components/Logo';
import { toast } from 'react-toastify';
import axios from 'axios';
import useResponsive from '../hooks/useResponsive';
import Key from '../clientVariables.json';
import Paymentinformation from './Paymentinformation';
import moment from 'moment';

const PaymentPermission = (props) => {
  const [packageDetails, setPackageDetails] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [salesPersonDetails, setSalesPersonDetails] = useState({});
  const [companyDetails, setCompanyDetails] = useState({});
  const [paymentResponse, setPaymentResponse] = useState({});
  const [paymentSuccssRes, setPaymentSuccessResponse] = useState({});
  const [paymentMsg, setPaymentMsg] = useState('');
  const [Alreadypayformshow, setAlreadypayformshow] = useState(false);
  const [paymentLinkExpired, setPaymentLinkExpired] = useState(false);

  const mdUp = useResponsive('up', 'md');

  useEffect(() => {
    const currentPath = window.location.pathname;
    const pathArray = currentPath.split('/');
    const emailToken = pathArray[2];
    const subscription_id = pathArray[3];
    console.log(emailToken);
    console.log(subscription_id);
    if (subscription_id !== '') {
      axios
        .post(`${Key.domain}/payment/get_paymentdetails`, {
          cust_email_token: emailToken,
          cust_subscription_id: subscription_id,
        })
        .then((response) => {
          console.log(response);
          if (response.data.data.packageDetails.payment_status == 1) {
            setAlreadypayformshow(true);
            setPaymentLinkExpired(false);
          } else if (response.data.data.packageDetails.payment_status == 2) {
            setPaymentLinkExpired(true);
            setAlreadypayformshow(false);
          } else {
            if (response.data.data) {
              if (response.data.data.packageDetails) {
                setPackageDetails(response.data.data.packageDetails);
              }
              if (response.data.data.userDetails) {
                console.log(response.data.data.userDetails);
                setUserDetails(response.data.data.userDetails);
              }
              if (response.data.data.salesPersonDetails) {
                setSalesPersonDetails(response.data.data.salesPersonDetails);
              }
              if (response.data.data.companyDetails) {
                setCompanyDetails(response.data.data.companyDetails);
              }
            }
          }
        });
    } else if (subscription_id == '') {
      axios
        .post(`${Key.domain}/payment/get_paymentdetails`, {
          cust_email_token: emailToken,
          cust_subscription_id: null,
        })
        .then((response) => {
          console.log(response);
          if (response.data.data.packageDetails.payment_status == 1) {
            setAlreadypayformshow(true);
          } else {
            if (response.data.data) {
              if (response.data.data.packageDetails) {
                setPackageDetails(response.data.data.packageDetails);
              }
              if (response.data.data.userDetails) {
                console.log(response.data.data.userDetails);
                setUserDetails(response.data.data.userDetails);
              }
              if (response.data.data.salesPersonDetails) {
                sessionStorage.setItem('invoice_id', response.data.data.salesPersonDetails?.invoice_no);
                setSalesPersonDetails(response.data.data.salesPersonDetails);
              }
              if (response.data.data.companyDetails) {
                setCompanyDetails(response.data.data.companyDetails);
              }
            }
          }
        });
    }
  }, []);

  const getPaymentResponse = (data, paymentResponse) => {
    setPaymentMsg(data);
    setPaymentSuccessResponse(
      paymentResponse?.transactionresponse?.charge
        ? paymentResponse?.transactionresponse?.charge
        : paymentResponse?.transactionresponse?.subscription
    );
  };

  function getFutureDate(days) {
    let package_start_date = new Date().toISOString();
    var contdate = moment(package_start_date).add(days, 'd');
    let package_end_date = contdate.format('LL'); // e.g., 25th May 2024

    // setPackageEndData(package_end_date);
    return package_end_date;
  }

  return (
    <div>
      {Alreadypayformshow ? (
        <p>
          <span style={{ paddingTop: '12px' }}>
            <Logo />
          </span>
          <center>
            <div style={{ marginTop: '180px', width: '50%' }}>
              <div class="alert alert-success" role="alert">
                Your payment has been processed successfully! payment link has been expired
              </div>
            </div>
          </center>
        </p>
      ) : paymentLinkExpired ? (
        <p>
          <span style={{ paddingTop: '12px' }}>
            <Logo />
          </span>
          <center>
            <div style={{ marginTop: '180px', width: '50%' }}>
              <div class="alert alert-success" role="alert">
                Your Payment link has been expired!
              </div>
            </div>
          </center>
        </p>
      ) : (
        <div className="container">
          {paymentMsg === 'active' || paymentMsg === 'succeeded' ? (
            <Paymentinformation
              paymentMsg={paymentMsg}
              paymentSuccess={paymentSuccssRes}
              userDetails={userDetails}
              packageDetails={packageDetails}
              salesPersonDetails={salesPersonDetails}
            />
          ) : (
            <div className="row">
              <div className="col-sm-7 col-md-12 col-sm-12 col-lg-7 card" style={{ padding: '3%' }}>
                <div className="">
                  <Logo />
                  <br />
                  <h4>Billing Information</h4>
                  <li className="list-group-item">
                    <div className="row mb-1">
                      <div className="col-5">
                        <b>Full Name</b>
                      </div>
                      <div className="col-1">:</div>
                      <div className="col-6">{userDetails.full_name ? userDetails.full_name : 'N/A'}</div>
                    </div>
                  </li>

                  <li className="list-group-item">
                    <div className="row mb-1">
                      <div className="col-5">
                        <b>Email</b>
                      </div>
                      <div className="col-1">:</div>
                      <div className="col-6">{userDetails.username ? userDetails.username : 'N/A'}</div>
                    </div>
                  </li>

                  <li className="list-group-item">
                    <div className="row mb-1">
                      <div className="col-5">
                        <b>Mobile</b>
                      </div>
                      <div className="col-1">:</div>
                      <div className="col-6">{userDetails.mobile ? userDetails.mobile : 'N/A'}</div>
                    </div>
                  </li>

                  <br />

                  {userDetails?.usertype === 'jobseeker' ? (
                    <div className="pt-2">
                      <h4>Subscription Information</h4>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Plan Opted</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{packageDetails.title ? packageDetails.title : 'Custom Plan'}</div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Early Job Access</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">Yes</div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Smart Resume Optimizer</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">Yes</div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Priority Resume Boost</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">Yes </div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Placement assistance as needed</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">Yes </div>
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Professional Connect</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">Yes </div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Instant Resume Builder</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">Yes </div>
                        </div>
                      </li>
                    </div>
                  ) : (
                    <div className="pt-2">
                      <h4>Subscription Information</h4>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Plan Opted</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{packageDetails.title ? packageDetails.title : 'Custom Plan'}</div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Job Posts</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {/* packageDetails.jobs_allowed ? packageDetails.jobs_allowed : 'N/A' */}
                            Unlimited
                          </div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Profile Views</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {packageDetails.resumeviews_allowed ? packageDetails.resumeviews_allowed : 'N/A'}
                          </div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Recruiters</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {packageDetails.users_allowed ? packageDetails.users_allowed : 'N/A'}
                          </div>
                        </div>
                      </li>
                    </div>
                  )}
                </div>
              </div>
              &nbsp;
              <div className="col-sm-4 col-md-12 col-lg-4 card" style={{ padding: '1%' }}>
                <div className="a">
                  <br />
                  <br />
                  <br />
                  <br />

                  <div className="pt-2 mt-4">
                    <h4>Order Summary</h4>
                    <div className="mt-2">
                      <li className="list-group-item ">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Sub Total</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {parseInt(packageDetails.trail_period) === 0 ? packageDetails.price : '1'} USD
                          </div>
                          {/* <div className="col-6">1 USD</div> */}
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Tax</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">0 USD</div>
                        </div>
                      </li>

                      <li className="list-group-item">
                        <div className="row mb-1">
                          <div className="col-5">
                            <b> Grand</b>
                          </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {parseInt(packageDetails.trail_period) === 0 ? packageDetails.price : '1'} USD
                          </div>
                          {/* <div className="col-6">1 USD</div> */}
                        </div>
                      </li>

                      {parseInt(packageDetails.trail_period) === 1 && (
                        <div className="" style={{ marginTop: '10px' }}>
                          Note : 1 USD will be refund immediately
                        </div>
                      )}
                      <div
                        style={{
                          display: 'flex',
                          // flexDirection: 'column',
                          // gap:"14px",
                          marginTop: '14px',
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', width: '50%' }}>
                          <div>
                            <b>Enrolled Date</b>
                          </div>
                          <div>
                            <b>Billing Date</b>
                          </div>
                          <div>
                            <b>Renewal Date</b>
                          </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                          <div>:&nbsp;&nbsp;&nbsp;{moment(packageDetails?.enrolled_date).format('LL')} </div>
                          <div>
                            :&nbsp;&nbsp;&nbsp;{' '}
                            {parseInt(packageDetails?.trail_period) === 0
                              ? moment(packageDetails?.enrolled_date).format('LL')
                              : moment(packageDetails?.package_start_date).format('LL')}{' '}
                          </div>
                          <div>
                            :&nbsp;&nbsp;&nbsp;
                            {moment(packageDetails?.package_end_date).format('LL')}
                          </div>
                        </div>
                      </div>

                      {/* getFutureDate(package_days)  moment(packageDetails?.package_end_date).add(30, 'days').calendar()*/}
                    </div>
                  </div>

                  <hr />

                  <Paymentform
                    packageDetails={packageDetails}
                    userDetails={userDetails}
                    salesPersonDetails={salesPersonDetails}
                    companyDetails={companyDetails}
                    getPaymentResponse={getPaymentResponse}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PaymentPermission;
